<div
  data-testid="reporting-period-container"
  class="reporting-period-container"
>
  <goab-text mt="xs" mb="xs" tag="span">
    <span data-testid="reporting-period" class="reporting-period"
      >Reporting for the week of: {{ dataEntry() | reportingPeriod }}</span
    >
  </goab-text>
  <goab-text mt="none" mb="xs" tag="span">
    <span data-testid="report-due" class="report-due"
      ><span class="bold-text">Report due: </span
      >{{ dataEntry()! | reportingPeriod : 'due' }}</span
    >
  </goab-text>
  <goab-text mt="none" mb="xs" tag="span">
    @if(dataEntry()?.completedOn) {
    <span data-testid="completed-on" class="completed-on"
      ><span class="bold-text">Completed on: </span
      >{{ dataEntry()! | reportingPeriod : 'completed' }}</span
    >
    } @else {
    <span data-testid="completed-on" class="completed-on"
      ><span class="bold-text">Completed on: </span>-</span
    >
    }
  </goab-text>
  <goab-text mt="none" mb="xs" tag="span">
    @if(dataEntry()?.reporter) {
    <span data-testid="reporter" class="reporter"
      ><span class="bold-text">Reporter: </span
      >{{ dataEntry()?.reporter }}</span
    >
    } @else {
    <span data-testid="reporter" class="reporter"
      ><span class="bold-text">Reporter: </span>-</span
    >
    }
  </goab-text>
  <goab-text mt="none" mb="none" tag="span">
    <span
      data-testid="facility-smoking-policy-confirmation"
      class="smoking-facility"
      ><span class="bold-text">Smoking policy confirmed: </span>
      {{ hasSmokingPolicy() ? 'Yes' : '-' }}&nbsp; @if(hasSmokingPolicy()) {
      <goab-link
        mt="none"
        mb="xs"
        [attr.id]="'facility-smoking-policy-confirmation-link'"
        data-testid="facility-smoking-policy-confirmation-link"
      >
        <a [routerLink]="['/help']" fragment="smokingPolicySection"
          >Change response</a
        >
      </goab-link>
      }
    </span>
  </goab-text>
</div>

<goab-divider mt="xl"></goab-divider>

<div data-testid="data-entry-grid" class="data-entry-container">
  <div data-testid="header-bed-type" class="header-cell">Bed type</div>
  <div data-testid="header-funded-beds" class="header-cell">Funded beds</div>
  <div data-testid="header-operational-beds" class="header-cell">
    Operational beds
  </div>
  <div data-testid="header-occupied-beds" class="header-cell">
    Occupied beds
    <div data-testid="subheader-occupied-beds" class="header-cell-subheading">
      *Include matched beds
    </div>
  </div>
  <div data-testid="header-vacancy" class="header-cell">Vacancy</div>

  <ng-container *ngIf="dataEntry()">
    <app-data-entry-row
      *ngFor="
        let dataEntryRow of rowsWithFundedBeds();
        let i = index;
        trackBy: trackByRow
      "
      [bedTypeDescription]="bedTypeDescription[i]"
      [attr.data-testid]="'data-entry-row-' + i"
      [dataEntryRow]="dataEntryRow"
      [index]="i"
      [status]="dataEntry()?.status"
      [totalRows]="rowsWithFundedBeds().length"
      [fieldToFocus]="
        localFieldToFocus()?.row === i ? localFieldToFocus()!.col : null
      "
      (dataEntryRowChange)="onDataEntryRowChange($event)"
      (fieldChange)="onFieldChange($event)"
      (fieldSelection)="onFieldSelection($any($event))"
      (tabDirection)="onTabDirection($any($event))"
      (changing)="changingCountLength.set($event)"
      (validationStatus)="onRowValidationStatus(i, $event.hasError)"
    ></app-data-entry-row>
  </ng-container>
</div>

@if(!isReadOnlySignal()) {
<div
  data-testid="no-changes-section"
  class="checkbox-container"
  *ngIf="chkNoChangesStateSignal().visible"
>
  <goab-form-item labelSize="regular">
    <goab-checkbox
      [data-testid]="'no-changes-checkbox'"
      name="item"
      text="No changes this week"
      ariaLabel="no-changes-checkbox"
      [disabled]="!chkNoChangesStateSignal().enabled"
      (onChange)="onNoChangesCheckboxChange($any($event))"
      [checked]="chkNoChangesStateSignal().checked"
    ></goab-checkbox>
  </goab-form-item>
</div>

@if(reasonsForChangeEnabled()) {
<app-reasons-for-change
  preventFocusScroll
  [targetSelector]="'mat-select, .cdk-overlay-pane'"
  [existingReasons]="dataEntry()?.reasonsForChange || []"
  (selectionChanged)="onReasonsForChange($event)"
  [disabled]="!reasonsForChangeEnabled()"
></app-reasons-for-change>

@if(showOtherReasons()){
<div class="other-reasons-container">
  <goab-text tag="h3" size="body-l" mb="none"
    ><span class="bold-text">Other</span></goab-text
  >
  <goab-form-item helpText="Reason(s) for change in number of operational beds."
    ><goab-input
      [attr.data-testid]="'other-reasons-text'"
      width="50ch"
      [maxLength]="50"
      (onBlur)="onOtherReasonBlur($any($event))"
      (onChange)="changingOtherReasonLength.set($event.value.trim().length)"
      [value]="dataEntry()?.otherReasonForChange"
    ></goab-input
  ></goab-form-item>
</div>
} }
<goab-divider mt="l" mb="none" *ngIf="!hasSmokingPolicy()"></goab-divider>
<div
  *ngIf="!hasSmokingPolicy()"
  data-testid="facility-smoking-policy-section"
  class="facility-smoking-policy-section"
>
  <goab-text
    tag="h3"
    size="body-l"
    [attr.data-testid]="'facility-smoking-policy-heading'"
    mb="xs"
    mt="2xl"
    class="reasons-for-change"
    ><span class="bold-text"
      >Does your facility have a smoking policy?</span
    ></goab-text
  >
  <goab-text
    size="body-s"
    tag="h4"
    mt="none"
    mb="l"
    [attr.data-testid]="'facility-smoking-policy-description'"
    >Please keep a copy of your policy handy in case it's requested for
    verification.</goab-text
  >
  <goab-form-item requirement="required" labelSize="regular" mt="m">
    <goab-radio-group
      name="smoking-policy"
      [value]="hasSmokingPolicy()"
      [attr.data-testid]="'smoking-policy-radio-group'"
      (onChange)="onSmokingPolicyChange($event)"
    >
      <goab-radio-item
        [attr.data-testid]="'smoking-policy-yes-radio-item'"
        radioItemHtmlLabel
        value="True"
        [customRadioHtmlLabel]="facilitySmokingPolicyYesLabel"
      ></goab-radio-item>
      <goab-radio-item
        [attr.data-testid]="'smoking-policy-no-radio-item'"
        value="False"
        radioItemHtmlLabel
        [customRadioHtmlLabel]="facilitySmokingPolicyNoLabel"
        style="margin-top: -3px"
      ></goab-radio-item>
    </goab-radio-group>
  </goab-form-item>
</div>

<goab-divider mt="2xl"></goab-divider>

<div data-testid="submit-section" class="button-container">
  <goab-button
    preventFocusScroll
    [targetSelector]="'goa-button'"
    [data-testid]="'save-for-later-button'"
    class="save-for-later-button"
    type="tertiary"
    size="compact"
    [disabled]="!isSaveLaterable()"
    (onClick)="onSaveLater()"
    [attr.type]="'button'"
  >
    Complete this entry later
  </goab-button>
  <goab-button
    preventFocusScroll
    [targetSelector]="'goa-button'"
    [data-testid]="'submit-button'"
    type="primary"
    size="compact"
    variant="normal"
    [disabled]="!isSubmittable()"
    (onClick)="onSubmit()"
    [attr.type]="'button'"
  >
    Finalize and submit
  </goab-button>
</div>
} @else { @if (doShowReasonsForChangeOnCompleted()) {
<goab-text
  tag="h3"
  mt="xl"
  mb="none"
  [attr.data-testid]="'reasons-for-change-heading_completed'"
  class="reasons-for-change"
  >Reason(s) for change in number of operational beds</goab-text
>
<ul class="reasons-list-completed" data-testid="reasons-list-completed">
  <li class="list-item" *ngFor="let reason of reasonsNoOther()">
    {{ reason }}
  </li>

  @if (doShowOtherReason()) {
  <li>
    <span class="other-reason-completed" data-testid="other-reason-completed"
      >Other:&nbsp;</span
    >{{ dataEntry()?.otherReasonForChange }}
  </li>
  }
</ul>
} }
